// extracted by mini-css-extract-plugin
module.exports = {"toolTip":"basic_toolTip__3GqB5"};